export class DialogConfig<D = any> {
  width?: number;
  height?: number;
  /** Valores mínimos opcionais para os handles de resize (px). */
  minWidth?: number;
  minHeight?: number;
  /** Na variante Container Queries, false preserva o Bootstrap viewport-based neste dialog. */
  bootstrapContainerQueries?: boolean;
  /** Desativa a animação Genie num dialog específico, se necessário. */
  genieAnimation?: boolean = true;
  data?: D;
  title?: string;
  iconTitle?: string;
  iconTitleBefore?: boolean;
  initialPositionX?: number;
  initialPositionY?: number;
  minimized?: boolean = false;
  /** Permite desativar o botão PiP num dialog específico, se necessário. */
  allowPictureInPicture?: boolean = true;
  template?: TemplateLayouts;
  dialogConfig?: DialogStyleConfig;
  tabConfig?: TabStyleConfig;
  dialogBodyStyle?: { [klass: string]: any; };
}

export class DialogStyleConfig {
  dialogColor: string = 'rgb(96, 96, 96)';
  dialogBackgroundColor: string = 'rgb(245, 248, 250)';
  iconColor: string = 'grey';
  iconHoverColor: string = 'black';
  dialogTitle?: string;
  matSliderColor?: string;
}

export class TabStyleConfig {
  tabBackGroundColor: string = 'white';
  tabColor: string = 'grey';
  tabBorderColor: string = 'grey';
  iconColor: string = '#a1a5b7';
  iconHoverColor: string = 'black';
  tabTitle?: string;
}

export enum TemplateLayouts {
  black = 'black',
  white = 'white',
  darkBlue = 'darkBlue',
  primary = 'primary',
  lightPrimary = 'light-primary',
  grey = 'grey',
  lightGrey = 'light-grey',
  entities = 'entities',
  tickets = 'tickets',
  opportunities = 'opportunities',
  history = 'history',
  leads = 'leads',
  contracts = 'contracts',
  bankAccounts = 'bankAccounts',
  accessRequests = 'accessRequests'
}